var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dojo landscape"},[_c('Portal'),_c('transition',{attrs:{"name":"fade"}},[(_vm.loaded)?_c('div',[_c('DojoCourse'),_c('Chat')],1):_vm._e()])],1),_c('div',{staticClass:"portrait"},[_c('NotOriented')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }